import script from "./ProjectRequestedComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectRequestedComponent.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectRequestedComponent.vue?vue&type=style&index=0&id=2a293b8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a293b8e"]])

export default __exports__